import { Messages } from '../../../../../../codegen/Localize';
import { ILogo, LogoService, LogoType } from '../services/LogoService';

export class LogoHelper {
  static async generatePreviewLogo(file: File, logoType: LogoType): Promise<ILogo> {
    try {
      const image = await LogoHelper.readFileAsImage(file);
      const previewLogo: ILogo = {
        image: image.src,
        width: image.width,
        height: image.height,
        href: '',
        title: '',
      };
      return Promise.resolve(LogoService.getScaledLogo(previewLogo, logoType));
    } catch (err) {
      return Promise.reject(err);
    }
  }

  static async readFileAsImage(file: File): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = () => reject(new Error(Messages.uploadSiteLogoErrorFileReadError()));
      reader.onload = () => {
        const image = new Image();
        image.src = reader.result as string;
        image.onload = () => resolve(image);
      };
      reader.readAsDataURL(file);
    });
  }
}
